import { ItemOrderSchemaType } from "./order.schema";

// Flag para controlar se deve usar a estrutura antiga (Legacy Sections)
export const SHOW_LEGACY_SECTIONS = false;

// CNPJ da Dustre filial ES, padrão do campo "Meu CNPJ"
export const DUSTRE_ES_CNPJ = '03954227000326';

const baseItemState = {
  isSaved: false,
  isPrincipal: false,
  subItems: [],
  priceDetails: {
    pricePerKgMin: undefined,
    pricePerKgFinal: undefined,
    unitPrice: undefined,
    itemSubtotal: undefined,
    itemTaxes: undefined,
    discount: undefined,
  },
};

const materialLegacyState = {
  requestedProductMaterial: {
    product: '',
    format: '',
    diameter: undefined,
    thickness: undefined,
    length: undefined,
    finishing: '',
    weigth: 'Auto',
    quantity: undefined,
    ncm: '',
    specs: '',
  },
  offeredProductMaterial: {
    product: '',
    format: '',
    diameter: undefined,
    thickness: undefined,
    length: undefined,
    finishing: '',
    weigth: 'Auto',
    quantity: undefined,
    ncm: '',
    specs: '',
  },
  deadlines: {
    internal: [
      { id: 'corte-serra-interno', label: 'Corte serra', checked: false, value: '' },
      { id: 'outros-cortes-interno', label: 'Outros cortes', checked: false, value: '' },
      { id: 'forja-interno', label: 'Forja', checked: false, value: '' },
      { id: 'tt-interno', label: 'TT', checked: false, value: '' },
      { id: 'usinagem-interno', label: 'Usinagem', checked: false, value: '' },
      { id: 'ensaios-interno', label: 'Ensaios', checked: false, value: '' },
      { id: 'entrega-interno', label: 'Entrega', checked: false, value: '' },
    ],
    external: [
      { id: 'corte-serra-externo', label: 'Corte serra', checked: false, value: '' },
      { id: 'outros-cortes-externo', label: 'Outros cortes', checked: false, value: '' },
      { id: 'forja-externo', label: 'Forja', checked: false, value: '' },
      { id: 'tt-externo', label: 'TT', checked: false, value: '' },
      { id: 'usinagem-externo', label: 'Usinagem', checked: false, value: '' },
      { id: 'ensaios-externo', label: 'Ensaios', checked: false, value: '' },
      { id: 'entrega-externo', label: 'Entrega', checked: false, value: '' },
    ],
  },
  heatTreatments: {
    tensionRelief: false,
    performance: false,
    aging: false,
    normalizationAndTempering: false,
    annealing: false,
    solutionTreatment: false,
    quenchingAndTempering: false,
  },
};

export const createItemInitialState = (
  type: 'MATERIAL' | 'PRODUCT' | 'SERVICE' | 'RESOURCE',
  isPrincipal = false
): ItemOrderSchemaType => {
  const item: Partial<ItemOrderSchemaType> = {
    ...baseItemState,
    itemType: type,
    isPrincipal: isPrincipal,
  };

  switch (type) {
    case 'MATERIAL':
      return {
        ...item,
        ...materialLegacyState,
        feedstock: { materiaPrima: '', quantidade: undefined, anexos: [], observacoes: '', stockDescription: '' },
      } as ItemOrderSchemaType;
    case 'PRODUCT':
      return {
        ...item,
        finalProduct: { produto: '', fabricante: '', script: '', quantidade: undefined, anexos: [], observacoes: '' },
      } as ItemOrderSchemaType;
    case 'SERVICE':
      return {
        ...item,
        stage: { servico: '', categoria: '', tipo: '', fornecedor: '', quantidade: undefined, anexos: [], observacoes: '' },
      } as ItemOrderSchemaType;
    case 'RESOURCE':
      return {
        ...item,
        resource: { insumo: '', categoria: '', tipo: '', fornecedor: '', quantidade: undefined, anexos: [], observacoes: '' },
      } as ItemOrderSchemaType;
    default:
      return item as ItemOrderSchemaType;
  }
};

export const itemInitialState: ItemOrderSchemaType = createItemInitialState('PRODUCT', true);

export const createSubItemInitialState = (itemType: 'MATERIAL' | 'PRODUCT' | 'RESOURCE' | 'SERVICE'): ItemOrderSchemaType => {
  return createItemInitialState(itemType, false);
};

export const FIELD_LABELS: { [key: string]: string } = {
  product: "Produto",
  itemType: "Tipo de Item",
  format: "Formato",
  diameter: "Diâmetro",
  thickness: "Espessura",
  length: "Comprimento",
  finishing: "Acabamento",
  weigth: "Peso",
  quantity: "Quantidade",
  ncm: "NCM",
  specs: "Especificações",
  pricePerKgMin: "Preço por Kg Mínimo",
  pricePerKgFinal: "Preço por Kg Final",
  unitPrice: "Preço Unitário",
  itemSubtotal: "Subtotal do Item",
  itemTaxes: "Impostos do Item",
  discount: "Desconto",
  additionalData: "Dados adicionais",
  nomeCustomizado: "Especificação",
  extraInfo: "Observações",
};

export const SECTION_LABELS: { [key: string]: string } = {
  requestedProductMaterial: "Produto Solicitado",
  offeredProductMaterial: "Produto Ofertado",
  priceDetails: "Detalhes de Preço",
  deadlines: "Prazos",
  heatTreatments: "Tratamentos Térmicos",
  subItems: "Sub-item",
  feedstock: "Matéria-prima",
  finalProduct: "Produto final",
  resource: "Insumo",
  stage: "Serviço",
};

export const DETAILS_FORM_DATA = {
  orderTypes: ["Compra", "Venda", "Transferência"],
  paymentTerms: ["À vista", "30 dias", "60 dias", "90 dias"],
  shippingTypes: ["FOB", "CIF", "Retirada no local"],
};


export const PAYMENT_METHOD_LABELS: { [key: string]: string } = {
  Dinheiro: 'Dinheiro',
  Cheque: 'Cheque',
  CartaoDeCredito: 'Cartão de Crédito',
  CartaoDeDebito: 'Cartão de Débito',
  BoletoBancario: 'Boleto Bancário',
  DepositoBancario: 'Depósito Bancário',
  PagamentoInstantaneoPix: 'Pix',
  TransferenciaBancariaCarteiraDigital: 'Transferência/Carteira Digital',
  PagamentoInstantaneoPixEstatico: 'Pix Estático',
  SemPagamento: 'Sem Pagamento',
  Outros: 'Outros',
};

export const paymentMethodLabel = (code?: string): string =>
  (code && PAYMENT_METHOD_LABELS[code]) || code || '';

export const BLOCKED_ATTACHMENT_EXTENSIONS = ['.exe', '.msi', '.bat', '.sh', '.zip', '.rar'];

export const SERVICES_FORM_DATA = {
  categories: ["Manutenção", "Usinagem", "Montagem", "Caldeiraria"],
  types: ["Preventiva", "Corretiva", "Melhoria Contínua", "Preditiva"],
};

export const RESOURCE_FORM_DATA = {
  categories: ["Parafusos", "Fixadores", "Fluidos", "EPIs"],
  types: ["Aço Carbono", "Aço Inox", "Latão", "Óleo Solúvel"],
};

export const FINAL_PRODUCT_FORM_DATA = {
  manufacturers: ["Fabricante A", "Fabricante B", "Fabricante C"],
  scripts: ["Script X", "Script Y", "Script Z"],
};

